module.exports = __webpack_public_path__ + "media/images/solution-cards-264e85f85ef738bf1676c4aa0ed7500a.png";